import React, { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFile, removeFile } from "../../../features/files/FileSlice";
import { addFile as addComplaintFile, removeFileFromPosition, updateDetails} from "../../../features/complaintPosition/ComplaintPositionSlice";
import close from '../../../img/close.svg';
import visibility from '../../../img/visibility.svg';
import { removeFileFromPositions, updateComplaintPosition } from "../../../features/complaintPositions/ComplaintPositionsSlice";
import { setHasAttachments } from "../../../features/hasAttachments/HasAttachmentsSlice";
import { validateFileSize } from "../../../features/files/FileValidator";

export const FileInput = ({ name, value, positionIdToEdit }) => {
  const [files, setFiles] = useState([]);
  const [fileSizeError, setFileSizeError] = useState(null); // New state for file size error
  const [key, setKey] = useState(Date.now()); 
  const dispatch = useDispatch();
  const complaintFiles = useSelector((state) => state.complaintPosition.files);
  const complaintPositions = useSelector((state) => state.complaintPositions.positions);
  const matchingPosition = complaintPositions.find((position) => position.id === positionIdToEdit);
  const filesToDisplay = matchingPosition ? matchingPosition.files : [];

  useEffect(() => {
    if (positionIdToEdit === null) {
      setFiles(complaintFiles);
    } else {
      const matchingPosition = complaintPositions.find((position) => position.id === positionIdToEdit);
      setFiles(matchingPosition ? matchingPosition.files : []);
    }
  }, [complaintFiles, complaintPositions, positionIdToEdit]);

  const handleFileInput = async (event) => {
    const selectedFiles = event.target.files;
    const newFiles = [];

    try {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        const base64 = await convertToBase64(file);
        validateFileSize(file, 5242880);

        newFiles.push({
          name: file.name,
          base64: base64,
          file: file,
        });
      }
     
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      dispatch(setFile(newFiles));
      dispatch(addComplaintFile(newFiles));
      if (positionIdToEdit !== null) {
        dispatch(updateComplaintPosition({ id: positionIdToEdit, files: [...filesToDisplay, ...newFiles] }));
      }

      dispatch(setHasAttachments(true));
      setFileSizeError(null); 
      setKey(Date.now()); 
    } catch (error) {
      console.error("Error handling file input:", error);
      setFileSizeError("Przekroczono maksymalny rozmiar pliku (5 MB).");
    }
  };


  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleRemoveClick = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });

    dispatch(removeFile({ index }));
    dispatch(removeFileFromPosition({ index }));
    if(positionIdToEdit)
    {
      dispatch(removeFileFromPositions({positionId:positionIdToEdit, index}))
    }
  };

  const handlePreviewClick = (base64) => {
    const newWindow = window.open();
    newWindow.document.write(`<iframe src="${base64}" width="100%" height="100%"></iframe>`);
  }; 

  const renderFileList = () => {
    if(positionIdToEdit > 0){
    const filesToRender = filesToDisplay;
    return filesToRender.map((file, index) => (
      <div key={index} style={{ marginBottom: "10px" }} className="file-item">
        <span>{file.name}</span>
        <img src={close} onClick={() => handleRemoveClick(index)}/>
        <img src={visibility} onClick={() => handlePreviewClick(file.base64)}/>
      </div>
    ));}
    else{
    const filesToRender = files;
    return filesToRender.map((file, index) => (
      <div key={index} style={{ marginBottom: "10px" }} className="file-item">
        <span>{file.name}</span>
        <img src={close} onClick={() => handleRemoveClick(index)}/>
        <img src={visibility} onClick={() => handlePreviewClick(file.base64)}/>
      </div>
    ));
    }
  };

  return (
    <div>
      <label htmlFor={name} id="file-label">
        Dodaj plik
      </label>
      <input
        key={key}
        type="file"
        name={name}
        id={name}
        onChange={handleFileInput}
        multiple
        value={value}
        
      />
      <div className="files-list">{renderFileList()}</div>
      
      {fileSizeError ? (
        <p className="error" style={{ marginTop: '0px' }}>
          {fileSizeError}
        </p>
      ):null}

    </div>
  );
};